module.exports = __webpack_public_path__ + "media/icons/facebook-white-25f73842.png";